import { useQuery } from '@tanstack/react-query';

import { Alert } from '@/shared/ui/alert';
import { Button } from '@/shared/ui/button';
import { LoadingStatus } from '@/shared/ui/spinner';

import { submissionFilesQuery } from '../api/submission-files';

import { ArtifactFileList } from './artifact-file-list';

/** Mount only after the learner requests the frozen source; never fetch live IDE files. */
export function SubmissionFiles({ submissionId }: { submissionId: string }) {
  const files = useQuery(submissionFilesQuery(submissionId));
  return (
    <div className="mt-3 space-y-2">
      {files.isPending ? <LoadingStatus label="Loading submitted files…" /> : null}
      {files.error ? (
        <div className="space-y-3">
          <Alert>Could not load these submitted files. Check your connection and try again.</Alert>
          <Button
            variant="secondary"
            loading={files.isFetching}
            loadingLabel="Loading submitted files…"
            onClick={() => void files.refetch()}
          >
            Retry loading files
          </Button>
        </div>
      ) : null}
      {files.data ? (
        <ArtifactFileList
          files={files.data.files}
          kind="Submitted"
          emptyMessage="This submission does not contain any supported source files."
        />
      ) : null}
    </div>
  );
}
